// eslint-disable-next-line import/prefer-default-export
export const TRANSACTION_TYPE_CONSTANTS = {
  ISSUANCE: 'issuance',
  TRANSFER_OK: 'transfer-ok',
  DESTROY: 'destroy',
  REDEMPTION: 'redemption',
};
